// extracted by mini-css-extract-plugin
module.exports = {"content":"BlankView_content__cvt6A","text":"BlankView_text__5AXVv"};